// ============================================
// LENS DRAWER - V5 FIXED
// All issues resolved
// ============================================

console.log('🚀 Lens v5 loading...');

// ==========================
// FRAME TYPE DETECTION
// ==========================

function detectFrameType() {
  // Check all possible selectors for product titles in cart
  const selectors = [
    '.cart-item__name',
    '.cart-item-title',
    '.product-title',
    '[data-product-title]',
    '.cart__item-title',
    'h3.cart-item__title',
    '.line-item__title'
  ];
  
  let isSunglasses = false;
  
  selectors.forEach(selector => {
    const items = document.querySelectorAll(selector);
    items.forEach(item => {
      const title = (item.textContent || item.innerText || item.dataset.productTitle || '').toLowerCase();
      if (title.includes('sunglass') || title.includes('sun glass') || title.includes('sunglasses')) {
        isSunglasses = true;
        console.log(`🕶️ Found sunglasses: ${title}`);
      }
    });
  });
  
  console.log(`📦 Frame type: ${isSunglasses ? 'Sunglasses' : 'Regular'}`);
  return isSunglasses;
}

function filterLensesByFrameType() {
  const isSunglasses = detectFrameType();
  // ONLY filter compact cards in drawer, NOT modal cards
  const compactCards = document.querySelectorAll('.lens-card-compact');
  
  let visibleCount = 0;
  
  compactCards.forEach(card => {
    const cats = (card.dataset.categories || '').toLowerCase();
    
    if (isSunglasses) {
      // Show only colored lenses for sunglasses
      if (cats.includes('colored')) {
        card.style.display = '';
        card.style.removeProperty('display');
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    } else {
      // For regular frames, show all non-colored lenses
      if (!cats.includes('colored')) {
        card.style.display = '';
        card.style.removeProperty('display');
        visibleCount++;
      } else {
        // Hide colored lenses for regular frames
        card.style.display = 'none';
      }
    }
  });
  
  console.log(`✅ ${visibleCount} compact lenses visible for ${isSunglasses ? 'sunglasses' : 'frames'}`);
  return isSunglasses;
}

// ==========================
// MODAL FUNCTIONS
// ==========================

function openLensModal() {
  console.log('🔄 Opening modal...');
  
  const modal = document.getElementById('lensModal');
  if (!modal) {
    console.error('❌ Modal not found');
    return false;
  }
  
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
  
  console.log('✅ Modal opened - showing all lenses');
  return true;
}

function closeLensModal() {
  const modal = document.getElementById('lensModal');
  if (modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
    console.log('✅ Modal closed');
  }
}

// ==========================
// FILTER SYSTEM
// ==========================

function initFilters() {
  const buttons = document.querySelectorAll('.filter-btn');
  const modalCards = document.querySelectorAll('.lens-card-h');
  
  if (buttons.length === 0) {
    console.warn('⚠️ No filter buttons');
    return;
  }
  
  if (modalCards.length === 0) {
    console.warn('⚠️ No modal cards found');
    return;
  }
  
  console.log(`📊 ${buttons.length} filters, ${modalCards.length} modal cards`);

  buttons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const filter = this.dataset.filter;
      console.log(`🔍 Modal filter: ${filter}`);

      // Update buttons
      buttons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      // Filter modal cards normally - show ALL lenses
      let count = 0;
      modalCards.forEach(card => {
        const cats = (card.dataset.categories || '').toLowerCase();
        
        if (filter === 'all') {
          // Show ALL lenses (power + colored)
          card.style.display = '';
          card.style.removeProperty('display');
          count++;
        } else {
          // Show specific category
          if (cats.includes(filter)) {
            card.style.display = '';
            card.style.removeProperty('display');
            count++;
          } else {
            card.style.display = 'none';
          }
        }
      });

      console.log(`✅ ${count} modal lenses visible`);
    });
  });
}

// ==========================
// CART OPERATIONS - KEEP DRAWER OPEN
// ==========================

function keepCartDrawerOpen() {
  console.log('🔒 Keeping cart drawer open...');
  
  // Multiple selectors for different themes
  const selectors = [
    '[id*="cart-drawer"]',
    '[class*="cart-drawer"]',
    '[id*="CartDrawer"]',
    '[class*="CartDrawer"]',
    '.drawer--cart',
    '#CartDrawer',
    '#cart-drawer',
    'cart-drawer',
    '[data-cart-drawer]'
  ];
  
  let cartDrawer = null;
  
  for (const selector of selectors) {
    cartDrawer = document.querySelector(selector);
    if (cartDrawer) {
      console.log(`✅ Found cart drawer: ${selector}`);
      break;
    }
  }
  
  if (cartDrawer) {
    // Force it to stay open
    cartDrawer.classList.add('active', 'is-open', 'open', 'drawer--open');
    cartDrawer.style.display = 'block';
    cartDrawer.style.visibility = 'visible';
    cartDrawer.style.transform = 'translateX(0)';
    cartDrawer.setAttribute('open', '');
    cartDrawer.setAttribute('aria-hidden', 'false');
    
    console.log('✅ Cart drawer forced open');
  } else {
    console.warn('⚠️ Cart drawer element not found');
  }
  
  // Also keep body scroll locked
  document.body.classList.add('overflow-hidden', 'cart-open');
}

function refreshCartContent() {
  console.log('🔄 Refreshing cart with totals...');
  
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      console.log('✅ Cart data:', cart);
      
      // Update cart count in header
      updateCartCount(cart.item_count);
      
      // Update cart total
      updateCartTotal(cart.total_price);
      
      // Keep drawer open FIRST
      keepCartDrawerOpen();
      
      // Dispatch multiple events for theme compatibility
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      document.dispatchEvent(new CustomEvent('ajaxCart.afterCartLoad', { detail: cart }));
      
      // Try Dawn theme specific refresh
      if (typeof window.cartDrawer !== 'undefined' && window.cartDrawer) {
        console.log('📞 Calling Dawn cartDrawer methods');
        if (typeof window.cartDrawer.renderContents === 'function') {
          window.cartDrawer.renderContents(cart);
        }
      }
      
      // Try theme-specific refresh functions
      if (typeof window.refreshCart === 'function') {
        console.log('📞 Calling window.refreshCart()');
        window.refreshCart();
      } else if (window.theme && window.theme.cart) {
        if (typeof window.theme.cart.refresh === 'function') {
          console.log('📞 Calling theme.cart.refresh()');
          window.theme.cart.refresh();
        } else if (typeof window.theme.cart.getCart === 'function') {
          console.log('📞 Calling theme.cart.getCart()');
          window.theme.cart.getCart();
        }
      } else if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.cart) {
        console.log('📞 Calling Shopify.theme.cart methods');
        if (typeof Shopify.theme.cart.refresh === 'function') {
          Shopify.theme.cart.refresh();
        }
      } else {
        // Fetch cart sections to update
        console.log('🔄 Fetching cart sections...');
        fetch('/cart?section_id=cart-drawer')
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Update cart drawer content
            const newContent = doc.querySelector('[id*="cart-items"], [class*="cart-items"]');
            const currentContent = document.querySelector('[id*="cart-items"], [class*="cart-items"]');
            
            if (newContent && currentContent) {
              currentContent.innerHTML = newContent.innerHTML;
              console.log('✅ Cart items updated');
            }
            
            // Update footer total
            const newFooter = doc.querySelector('[id*="cart-footer"], [class*="cart-footer"]');
            const currentFooter = document.querySelector('[id*="cart-footer"], [class*="cart-footer"]');
            
            if (newFooter && currentFooter) {
              currentFooter.innerHTML = newFooter.innerHTML;
              console.log('✅ Cart footer updated');
            }
            
            keepCartDrawerOpen();
          })
          .catch(err => {
            console.error('❌ Section fetch failed:', err);
            // Last resort - reload but keep cart open
            sessionStorage.setItem('reopenCart', 'true');
            window.location.reload();
          });
      }
      
      // Keep checking drawer stays open
      setTimeout(() => keepCartDrawerOpen(), 100);
      setTimeout(() => keepCartDrawerOpen(), 300);
      setTimeout(() => keepCartDrawerOpen(), 500);
      
    })
    .catch(err => {
      console.error('❌ Cart refresh failed:', err);
      // As last resort, reload but try to reopen cart
      sessionStorage.setItem('reopenCart', 'true');
      window.location.reload();
    });
}

function updateCartCount(count) {
  // Update cart count bubble
  const countSelectors = [
    '[data-cart-count]',
    '.cart-count',
    '#cart-count',
    '[id*="cart-count"]',
    '[class*="cart-count"]',
    '.cart-count-bubble'
  ];
  
  countSelectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      el.textContent = count;
      el.setAttribute('data-cart-count', count);
    });
  });
  
  console.log(`✅ Cart count updated: ${count}`);
}

function updateCartTotal(totalPrice) {
  // Format price
  const formattedPrice = (totalPrice / 100).toFixed(2);
  const priceWithCommas = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2
  }).format(totalPrice / 100);
  
  console.log(`💰 Updating total to: ${priceWithCommas}`);
  
  // Update total price elements
  const totalSelectors = [
    '[data-cart-total]',
    '.cart-total',
    '#cart-total',
    '[id*="cart-total"]',
    '[class*="cart-total"]',
    '.cart-total-price',
    '[data-total-price]',
    '.totals__total-value',
    '[data-cart-subtotal]'
  ];
  
  totalSelectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      el.textContent = priceWithCommas;
      el.setAttribute('data-cart-total', totalPrice);
    });
  });
  
  // SPECIFICALLY update checkout button
  const checkoutButtons = document.querySelectorAll('[name="checkout"], [href*="/checkout"], .cart__checkout, button[type="submit"]');
  
  checkoutButtons.forEach(btn => {
    const btnText = btn.textContent || btn.innerText;
    
    // If button contains price, update it
    if (btnText.includes('₹') || btnText.toLowerCase().includes('checkout')) {
      // Extract and replace price pattern
      const newText = btnText.replace(/₹[\d,]+\.?\d*/g, priceWithCommas);
      
      // Update all text nodes
      const textNodes = [];
      const walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null, false);
      let node;
      while (node = walker.nextNode()) {
        if (node.nodeValue.trim()) {
          textNodes.push(node);
        }
      }
      
      textNodes.forEach(textNode => {
        textNode.nodeValue = textNode.nodeValue.replace(/₹[\d,]+\.?\d*/g, priceWithCommas);
      });
      
      console.log(`✅ Updated checkout button: ${newText}`);
    }
  });
  
  // Also update any element with "Checkout" text and price
  const allElements = document.querySelectorAll('*');
  allElements.forEach(el => {
    // Only check elements with checkout-related classes or text
    if (el.className && typeof el.className === 'string' && 
        (el.className.includes('checkout') || el.className.includes('total'))) {
      
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
      let node;
      while (node = walker.nextNode()) {
        if (node.nodeValue.includes('₹') && node.nodeValue.match(/₹[\d,]+\.?\d*/)) {
          node.nodeValue = node.nodeValue.replace(/₹[\d,]+\.?\d*/g, priceWithCommas);
        }
      }
    }
  });
  
  console.log(`✅ Cart total updated: ${priceWithCommas}`);
}

// Check if we should reopen cart after reload
if (sessionStorage.getItem('reopenCart') === 'true') {
  sessionStorage.removeItem('reopenCart');
  setTimeout(() => {
    const cartIcon = document.querySelector('[href*="/cart"], [data-cart-icon], .cart-icon, #cart-icon');
    if (cartIcon) cartIcon.click();
  }, 500);
}

async function addLensToCart(variantId, lensName, lensPrice) {
  console.log(`🛒 Adding: ${lensName} (${variantId})`);
  
  const btn = window.event ? window.event.target.closest('button') : null;
  let origText = '';
  
  if (btn) {
    origText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span style="font-size:11px">Adding...</span>';
    btn.style.opacity = '0.7';
  }

  try {
    if (!variantId) throw new Error('Invalid variant ID');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('properties[Lens Type]', lensName);
    
    if (lensPrice > 0) {
      formData.append('properties[Lens Price]', `₹${Math.round(lensPrice / 100)}`);
    }

    console.log(`📤 Request sent...`);
    
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    });

    if (res.status === 422) {
      const err = await res.json();
      throw new Error(`Unavailable: ${err.description || err.message || 'Not found'}`);
    }

    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.description || err.message || `Error ${res.status}`);
    }

    const data = await res.json();
    console.log('✅ Added:', data);

    if (btn) {
      btn.innerHTML = '<span style="font-size:11px">✓ Added!</span>';
      btn.style.background = '#059669';
      btn.style.borderColor = '#059669';
      btn.style.opacity = '1';
    }
    
    // Refresh but keep drawer open
    setTimeout(() => {
      refreshCartContent();
    }, 600);

  } catch (error) {
    console.error('❌ Failed:', error);
    
    if (btn) {
      btn.innerHTML = '<span style="font-size:10px">Failed</span>';
      btn.style.background = '#DC2626';
      btn.style.borderColor = '#DC2626';
      
      setTimeout(() => {
        btn.innerHTML = origText;
        btn.style.background = '';
        btn.style.borderColor = '';
        btn.style.opacity = '';
        btn.disabled = false;
      }, 2500);
    }
    
    alert(error.message);
  }
}

async function addLensFromModal(variantId, lensName, lensPrice) {
  await addLensToCart(variantId, lensName, lensPrice);
}

// ==========================
// INITIALIZATION
// ==========================

function init() {
  console.log('🔧 Init...');
  
  const modal = document.getElementById('lensModal');
  if (!modal) {
    console.warn('⚠️ Waiting...');
    return false;
  }
  
  console.log('✅ Found modal');
  initFilters();
  
  // Apply filter immediately for compact cards
  filterLensesByFrameType();
  
  // Watch for cart drawer opening
  observeCartDrawer();
  
  if (!window.lensEscAdded) {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeLensModal();
    });
    window.lensEscAdded = true;
  }
  
  return true;
}

// Watch for cart drawer opening
function observeCartDrawer() {
  // Watch for cart drawer visibility changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && 
          (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
        // Cart drawer might have opened, refilter with delay
        setTimeout(() => {
          filterLensesByFrameType();
        }, 200);
      }
      
      // Also watch for content changes (items added/removed)
      if (mutation.type === 'childList') {
        setTimeout(() => {
          filterLensesByFrameType();
        }, 200);
      }
    });
  });
  
  // Observe cart drawer for both attributes AND content changes
  const cartDrawer = document.querySelector('[id*="cart"], [class*="cart-drawer"], [class*="drawer"]');
  if (cartDrawer) {
    observer.observe(cartDrawer, { 
      attributes: true,
      childList: true,
      subtree: true 
    });
    console.log('👁️ Watching cart drawer');
  }
  
  // Also watch body for class changes
  observer.observe(document.body, { attributes: true });
  
  // Watch for cart items container specifically
  const cartItems = document.querySelector('[id*="cart-items"], [class*="cart-items"]');
  if (cartItems) {
    observer.observe(cartItems, { 
      childList: true,
      subtree: true 
    });
    console.log('👁️ Watching cart items');
  }
}

// Also trigger filter after cart refresh
function refreshCartContent() {
  console.log('🔄 Refreshing cart with totals...');
  
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      console.log('✅ Cart data:', cart);
      
      // Update cart count in header
      updateCartCount(cart.item_count);
      
      // Update cart total
      updateCartTotal(cart.total_price);
      
      // Keep drawer open FIRST
      keepCartDrawerOpen();
      
      // Dispatch multiple events for theme compatibility
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      document.dispatchEvent(new CustomEvent('ajaxCart.afterCartLoad', { detail: cart }));
      
      // Try Dawn theme specific refresh
      if (typeof window.cartDrawer !== 'undefined' && window.cartDrawer) {
        console.log('📞 Calling Dawn cartDrawer methods');
        if (typeof window.cartDrawer.renderContents === 'function') {
          window.cartDrawer.renderContents(cart);
        }
      }
      
      // Try theme-specific refresh functions
      if (typeof window.refreshCart === 'function') {
        console.log('📞 Calling window.refreshCart()');
        window.refreshCart();
      } else if (window.theme && window.theme.cart) {
        if (typeof window.theme.cart.refresh === 'function') {
          console.log('📞 Calling theme.cart.refresh()');
          window.theme.cart.refresh();
        } else if (typeof window.theme.cart.getCart === 'function') {
          console.log('📞 Calling theme.cart.getCart()');
          window.theme.cart.getCart();
        }
      } else if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.cart) {
        console.log('📞 Calling Shopify.theme.cart methods');
        if (typeof Shopify.theme.cart.refresh === 'function') {
          Shopify.theme.cart.refresh();
        }
      } else {
        // Fetch cart sections to update
        console.log('🔄 Fetching cart sections...');
        fetch('/cart?section_id=cart-drawer')
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Update cart drawer content
            const newContent = doc.querySelector('[id*="cart-items"], [class*="cart-items"]');
            const currentContent = document.querySelector('[id*="cart-items"], [class*="cart-items"]');
            
            if (newContent && currentContent) {
              currentContent.innerHTML = newContent.innerHTML;
              console.log('✅ Cart items updated');
            }
            
            // Update footer total
            const newFooter = doc.querySelector('[id*="cart-footer"], [class*="cart-footer"]');
            const currentFooter = document.querySelector('[id*="cart-footer"], [class*="cart-footer"]');
            
            if (newFooter && currentFooter) {
              currentFooter.innerHTML = newFooter.innerHTML;
              console.log('✅ Cart footer updated');
            }
            
            keepCartDrawerOpen();
            
            // Re-filter lenses after content update
            setTimeout(() => {
              filterLensesByFrameType();
            }, 300);
          })
          .catch(err => {
            console.error('❌ Section fetch failed:', err);
            // Last resort - reload but keep cart open
            sessionStorage.setItem('reopenCart', 'true');
            window.location.reload();
          });
      }
      
      // Keep checking drawer stays open
      setTimeout(() => keepCartDrawerOpen(), 100);
      setTimeout(() => keepCartDrawerOpen(), 300);
      setTimeout(() => keepCartDrawerOpen(), 500);
      
      // Re-filter lenses after all updates
      setTimeout(() => {
        filterLensesByFrameType();
      }, 800);
      
    })
    .catch(err => {
      console.error('❌ Cart refresh failed:', err);
      // As last resort, reload but try to reopen cart
      sessionStorage.setItem('reopenCart', 'true');
      window.location.reload();
    });
}

function tryInit() {
  if (!init()) {
    setTimeout(tryInit, 500);
  } else {
    console.log('✅ Ready');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tryInit);
} else {
  tryInit();
}

// Globals
window.openLensModal = openLensModal;
window.closeLensModal = closeLensModal;
window.addLensToCart = addLensToCart;
window.addLensFromModal = addLensFromModal;
window.detectFrameType = detectFrameType;
window.filterLensesByFrameType = filterLensesByFrameType;

console.log('✅ Loaded');